export const ROUTE_CARRIER_COMPANY = 'carrier-company';
export const ROUTE_CARRIER_COMPANY_MENU = 'menu';






